// ResetContext.tsx
import React from "react";

type ResetCtx = { reset: () => void };
export const ResetContext = React.createContext<ResetCtx>({ reset: () => {} });

export function ResetProvider({ children }: { children: React.ReactNode }) {
  const [version, setVersion] = React.useState(0);
  const reset = () => setVersion((v) => v + 1);

  return (
    <ResetContext.Provider value={{ reset }}>
      {/* version değişince buradaki ağaç komple remount olur */}
      <div key={version}>{children}</div>
    </ResetContext.Provider>
  );
}
